import React from 'react';
import { RxCross2 } from 'react-icons/rx'; // Slightly more modern 'X'
import { BsPatchCheckFill } from "react-icons/bs";
import { CgDanger } from "react-icons/cg";

const AlertBox = ({ message, status, onClose }) => {
  // Close if user clicks outside the modal
  const handleOnClose = (e) => {
    if (e.target.id === 'container') onClose();
  }

  return (
    <div
      id='container'
      onClick={handleOnClose}
      className='fixed inset-0 z-[999] flex justify-center items-center bg-slate-900/40 backdrop-blur-sm transition-all'
    >
      <div className="bg-white m-4 rounded-3xl shadow-2xl border border-slate-100 overflow-hidden w-full max-w-[450px] animate-in fade-in zoom-in duration-200">
        
        {/* Header Section */}
        <div className='flex justify-between items-center px-6 py-4 border-b border-slate-50'>
          <div className="flex items-center gap-2">
            <div className={`w-2 h-2 rounded-full ${status ? 'bg-green-500' : 'bg-red-500'}`} />
            <p className={`font-black uppercase tracking-widest text-[10px] ${status ? 'text-green-600' : 'text-red-600'}`}>
              {status ? 'Action Successful' : 'Action Failed'}
            </p>
          </div>
          <button 
            onClick={onClose}
            className="p-1 hover:bg-slate-100 rounded-full transition-colors text-slate-400 hover:text-slate-900"
          >
            <RxCross2 size={20} />
          </button>
        </div>

        {/* Content Section */}
        <div className="flex flex-col items-center p-10 text-center">
          <div className={`mb-6 p-4 rounded-full ${status ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'}`}>
            {status ? <BsPatchCheckFill size={56} /> : <CgDanger size={56} />}
          </div>
          
          <h3 className="text-xl font-black text-slate-900 mb-2">
            {status ? "Great News!" : "Oops!"}
          </h3>
          
          <p className="text-slate-500 font-medium leading-relaxed">
            {message}
          </p>
        </div>

        {/* Action Section */}
        <div className="p-6 bg-slate-50/50 border-t border-slate-100">
          <button
            onClick={onClose}
            className={`w-full py-4 rounded-2xl font-black text-sm uppercase tracking-wider transition-all active:scale-95 shadow-lg ${
              status 
              ? 'bg-slate-900 text-white hover:bg-black shadow-slate-200' 
              : 'bg-red-600 text-white hover:bg-red-700 shadow-red-100'
            }`}
          >
            {status ? 'Continue' : 'Try Again'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default AlertBox;